

<div class="symbol">
    <div class="line-vertical line-v1"></div>
    <div class="line-vertical line-v2"></div>
    <div class="line-horizontal line-h1"></div>
    <div class="line-horizontal line-h2"></div>
    <div class="block block-1"></div>
    <div class="block block-2"></div>
    <div class="block block-3"></div>
    <div class="block block-4"></div>
</div>